/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimit/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimit/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimit/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimit/slot-game/bin/asset/assettypes/SpineAsset";
import {ImgLoader} from "@nolimit/slot-launcher/bin/loader/ImgLoader";

export class NineToFiveGameAssets {

    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_FS_MULTI = "Numbers_Multi";
    static BIG_WIN_SPINE = "spine/Big_Win.json";
    static NO_WIN_SPINE = "spine/No_Win.json";
    static MAX_WIN_SPINE = "spine/Max_Win.json";
    static FS_MULTI_PACER = "Multi_Counter";
    static SFS_MULTI_PACER = "Multi_Counter_SFS";

    public static MAIN_GAME_BACKGROUND:string = "resources/images/Intro_BG.jpg";
    public static get MAIN_GAME_BACKGROUND_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(NineToFiveGameAssets.MAIN_GAME_BACKGROUND);
    }

    static IMAGES_LOGO:string = "resources/images/introLogo.png";
    static get IMAGES_LOGO_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(NineToFiveGameAssets.IMAGES_LOGO);
    }

    static BASE_GAME_BACKGROUND:string = "BG_Main"
    static FREESPINS_BACKGROUND:string = "BG_FS"
    static SUPER_FREESPINS_BACKGROUND:string = "BG_SFS"

    // spines
    static SCATTER = "spine/Scatter.json"
    static SYMBOL_WIN = "spine/SYM_Win.json"
    static SYMBOL_WILD = "spine/Wild.json"
    static FS_INTRO = "spine/FS_Intro.json"
    static FS_OVERTIME = "spine/FS_Overtime.json"
    static X_NUDGE = "spine/XN.json"
    static GAME_INTRO = "spine/Intro.json"
    static XBET_DOOR = "spine/X_Bet_Reel.json"
    static XNUDGE_EXPLOSION = "spine/X_Nudge_FX.json"
    static SFS_BACKGROUND = "spine/SFS_Water.json"
    static GOD_MODE_POPUP = "spine/Pop_Up_God_Mode.json"

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro:[],

        main:[
            {
                name:"fonts",
                assets:[
                    new BitmapFontAsset(NineToFiveGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(NineToFiveGameAssets.BITMAP_FONT_FS_MULTI, "fonts/bitmapfonts/Numbers_Multi.fnt"),
                ]
            },
            {
                name:"spine",
                assets:[
                    new SpineAsset(NineToFiveGameAssets.SCATTER, NineToFiveGameAssets.SCATTER),
                    new SpineAsset(NineToFiveGameAssets.SYMBOL_WIN, NineToFiveGameAssets.SYMBOL_WIN),
                    new SpineAsset(NineToFiveGameAssets.SYMBOL_WILD, NineToFiveGameAssets.SYMBOL_WILD),
                    new SpineAsset(NineToFiveGameAssets.BIG_WIN_SPINE, NineToFiveGameAssets.BIG_WIN_SPINE),
                    new SpineAsset(NineToFiveGameAssets.FS_INTRO, NineToFiveGameAssets.FS_INTRO),
                    new SpineAsset(NineToFiveGameAssets.FS_OVERTIME, NineToFiveGameAssets.FS_OVERTIME),
                    new SpineAsset(NineToFiveGameAssets.NO_WIN_SPINE, NineToFiveGameAssets.NO_WIN_SPINE),
                    new SpineAsset(NineToFiveGameAssets.MAX_WIN_SPINE, NineToFiveGameAssets.MAX_WIN_SPINE),
                    new SpineAsset(NineToFiveGameAssets.X_NUDGE, NineToFiveGameAssets.X_NUDGE),
                    new SpineAsset(NineToFiveGameAssets.GAME_INTRO, NineToFiveGameAssets.GAME_INTRO),
                    new SpineAsset(NineToFiveGameAssets.XBET_DOOR, NineToFiveGameAssets.XBET_DOOR),
                    new SpineAsset(NineToFiveGameAssets.XNUDGE_EXPLOSION, NineToFiveGameAssets.XNUDGE_EXPLOSION),
                    new SpineAsset(NineToFiveGameAssets.SFS_BACKGROUND, NineToFiveGameAssets.SFS_BACKGROUND),
                    new SpineAsset(NineToFiveGameAssets.GOD_MODE_POPUP, NineToFiveGameAssets.GOD_MODE_POPUP),
                ]
            },
            {
                name:"main",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"), 
                ],
            },
            {
                name:"backgroundJpeg",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                ],
                //animations: {
                //    [TheCageGameAssets.MULTIPLIER_UPDATE] : "winMulteffect/winMulteffect_"
                //}
            },
            {
                name:"mainJpeg",
                assets:[
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                ],
                //animations: {
                //    [TheCageGameAssets.MULTIPLIER_UPDATE] : "winMulteffect/winMulteffect_"
                //}
            },
            //{
            //    name:"noTinyPng",
            //    autoLoad:[AssetQualityLevel.HIGH],
            //    assets:[
            //        new TextureAsset("noTinyPng0", "sheets/noTinyPng/noTinyPng0.json")
            //    ]
            //},
            {
                name:"symbols",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations:{}
            }
        ]
    };

}
